export async function withTimeout<T>(
  promise: Promise<T>,
  timeoutMs = 1000 * 10 //デフォルト10秒
): Promise<T> {
  const timeoutPromise = new Promise<never>((_, reject) =>
    setTimeout(
      () => reject(new Error(`Timeout after ${timeoutMs} ms`)),
      timeoutMs
    )
  );

  return Promise.race([promise, timeoutPromise]);
}
